<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp"> </p>
<blockquote epub:type="epigraph" role="doc-epigraph">
<blockquote>
<p class="V2"><span aria-label="4" id="pg_4" role="doc-pagebreak"><i>I never needed a Man.</i></span></p>
<p class="V"><i>I needed a Viking.</i></p>
<p class="V"><i>I needed someone who wasn’t afraid</i></p>
<p class="V"><i>of my strengths</i></p>
<p class="V"><i>or of my needs.</i></p>
<p class="V"><i>I chose wrong</i></p>
<p class="V"><i>in the past.</i></p>
<p class="V"><i>I thought I had to find someone who</i></p>
<p class="V"><i>could put up with my hunger for life.</i></p>
<p class="V"><i>But I was so damn wrong.</i></p>
<p class="V"><i>I needed a Viking.</i></p>
<p class="V"><i>I needed someone who could admire</i></p>
<p class="V"><i>all the things about me</i></p>
<p class="V"><i>that tepid men were intimidated by.</i></p>
</blockquote>
</blockquote>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?0312e314